import { ServiceMessage } from 'containers/Services/utils';
import { permissions, useHasPermission } from 'features/permissions';
import { useCallback } from 'react';
import { useHistory } from 'react-router';

export function useRedirectToServices(
  message: ServiceMessage = ServiceMessage.Blocked
) {
  const history = useHistory();
  const isStaff = useHasPermission(permissions.isStaff);
  return useCallback(() => {
    if (isStaff) return;
    history.replace('/services', { message });
  }, [history, isStaff, message]);
}
